import React, { useEffect, useState } from "react";
import { read, utils } from 'xlsx';
import { useDispatch, useSelector } from 'react-redux';
import './table.scss'
import { generatePrintedForm } from '../../../helpers/common';
import { ActionButton } from '../../common';
import { resetWebForm } from '../../../redux/actions/contractAction';


const ReadExcel = ({ fileName, setTypeDataState }) => {

    const dispatch = useDispatch();
    const { report } = useSelector(({ contract }) => contract);
    const [ rows, setRows]  = useState([]);

    useEffect(() => {
        if (report) {
            const wb = read(report.content, {  type: 'base64',cellFormula: true });

            const ws = wb.Sheets[wb.SheetNames[0]];
            const data = utils.sheet_to_json(ws, {
                header: 1,
                defval: "",
                cellFormula: true
            });
            setRows(data)
        }
    }, [report]);

    const downloadFile = () => {
        generatePrintedForm(report, fileName, 'xlsx')
        dispatch(resetWebForm())
        setTypeDataState(null)
        setRows([])
    }

    const row = rows.map((items, i) => {
            return  (
                <tr key={i} className={'report_tr'}>
                    {
                        items.map((cell, ind) => (
                            <td className={'report_td'} key={ind}>
                                {(cell === Number(cell) && cell !== 0) ? cell.toFixed(2) : cell}
                            </td>
                        ))
                    }
                </tr>
            )
        }
    )

    return (
        <>
            {
                report &&
                <div className={'flex_wrapper flex-column'}>
                    <table className={'report_table'}>
                        <tbody>
                        {row}
                        </tbody>
                    </table>
                    <div className={'button-wrapper m-b-spacer m-r-spacer'}>
                        <ActionButton
                            styleName={"download"}
                            text={'Сохранить'}
                            func={downloadFile}
                        />
                    </div>
                </div>
            }
        </>
    );
}

export default ReadExcel;